/**
 * <s-promo-popup> — opens its <dialog> once per visitor after [data-delay] seconds
 * (remembered in localStorage). Reopens with the thank-you state after a popup signup posts.
 */
const STORAGE_KEY = 'mevaro-promo-popup';

class SPromoPopup extends HTMLElement {
  #timer = 0;
  #ac;

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    const form = this.closest('form');
    form?.addEventListener('submit', () => this.#remember('submitted'), opts);
    this.dialog.addEventListener('close', () => this.#remember('seen'), opts);
    this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, opts);

    const state = this.#read();
    if (this.hasAttribute('data-posted') && state === 'submitted') {
      this.dialog.showModal();
      this.#remember('done');
      return;
    }
    if (state) return;
    const delay = Number(this.dataset.delay || 8) * 1000;
    this.#timer = window.setTimeout(() => {
      if (!document.querySelector('dialog[open]')) this.dialog.showModal();
    }, delay);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#ac?.abort();
  }

  #read() {
    try { return localStorage.getItem(STORAGE_KEY); } catch { return 'seen'; }
  }

  #remember(value) {
    try {
      if (value === 'seen' && this.#read()) return;
      localStorage.setItem(STORAGE_KEY, value);
    } catch { /* storage blocked: popup simply won't persist */ }
  }
}

if (!customElements.get('s-promo-popup')) customElements.define('s-promo-popup', SPromoPopup);
